import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, Mail, Menu, X } from 'lucide-react';
import { COLORS } from '../utils/colors';

// Modern header component with logo
const Header = ({ onBack, transparent = false }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const bgClass = transparent && !scrolled 
    ? 'bg-transparent' 
    : 'bg-white/95 backdrop-blur-sm shadow-sm';
  
  return (
    <header className={`fixed w-full z-40 transition-all duration-300 ${bgClass}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center gap-3">
            {onBack && (
              <button 
                onClick={onBack}
                className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
            )}
            <Link to="/" className="flex items-center">
              <img 
                src="/logo.svg" 
                alt="Lusidea" 
                className="h-8 md:h-10" 
              />
            </Link>
          </div>
          
          <div className="hidden md:flex items-center gap-6">
            <a 
              href="/" 
              className="text-gray-600 hover:text-red-600 transition-colors font-medium"
            >
              Home
            </a>
            <a 
              href="#trends" 
              className="text-gray-600 hover:text-red-600 transition-colors font-medium"
            >
              Trends
            </a>
            <a 
              href="#approach" 
              className="text-gray-600 hover:text-red-600 transition-colors font-medium"
            >
              Our Approach
            </a>
            <a 
              href="#contact" 
              className="text-gray-600 hover:text-red-600 transition-colors font-medium"
            >
              Contact
            </a>
            <button 
              className="ml-2 px-5 py-2.5 text-white rounded-lg transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] font-medium flex items-center gap-2"
              style={{ backgroundColor: COLORS.primary }}
            >
              <Mail className="w-4 h-4" />
              <span>Let's Talk</span>
            </button>
          </div>
          
          <button 
            className="md:hidden p-2 text-gray-600"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      
      {/* Mobile menu with animation */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-3 shadow-lg animate-fadeIn">
          <nav className="space-y-3">
            <a 
              href="#home" 
              className="flex items-center gap-2 py-2 text-gray-600 hover:text-red-600"
              onClick={() => setMenuOpen(false)}
            >
              <span>Home</span>
            </a>
            <a 
              href="#trends" 
              className="flex items-center gap-2 py-2 text-gray-600 hover:text-red-600"
              onClick={() => setMenuOpen(false)}
            >
              <span>Trends</span>
            </a>
            <a 
              href="#approach" 
              className="flex items-center gap-2 py-2 text-gray-600 hover:text-red-600"
              onClick={() => setMenuOpen(false)}
            >
              <span>Our Approach</span>
            </a>
            <a 
              href="#contact" 
              className="flex items-center gap-2 py-2 text-gray-600 hover:text-red-600"
              onClick={() => setMenuOpen(false)}
            >
              <span>Contact</span>
            </a>
            <button className="w-full mt-2 px-4 py-2.5 text-white rounded-lg transition-colors flex items-center justify-center gap-2"
              style={{ backgroundColor: COLORS.primary }}>
              <Mail className="w-4 h-4" />
              <span>Let's Talk</span>
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;